export const createContestsEditionLogsRequests = (client) => ({
    listContestsEditionLogs: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_logs", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map